module.exports = __webpack_public_path__ + "img/401.b61969d3.png";